import React, { useRef } from 'react';
import PropTypes from 'prop-types';
//Material Imports
import { Card } from '@material-ui/core';
import List from '@material-ui/core/List';
import { makeStyles } from '@material-ui/core/styles';
//Component Imports
import PopUpModal from '../PopUpModal';

//style
import './styles.scss';

const useStyles = makeStyles(theme => ({
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%'
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '80%'
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '35%'
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '35%'
    }
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px'
  }
}));

const ChapterCard = props => {
  const classes = useStyles();
  const childRef = useRef();

  const body = (
    <div className="list-content">
      <div className="list-header">
        <p className="sub-text uppercase mb-5">{props.subject}</p>
        <p className="topic">{props.topic}</p>
      </div>
      <List>{props.list}</List>
    </div>
  );
  const header = <div> {props.headerText} </div>;
  return (
    <React.Fragment>
      {props.homepage ? (
        <div
          className=" card chapter-card home-downloads"
          onClick={() => {
            childRef.current.handleClickOpen();
            props.handler(props.uniqueCode);
          }}
        >
          <div className="card-head">
            {props.showSubjectName && (
              <p className="sub-text uppercase mb-10">{props.subject}</p>
            )}
            <p className="sub-text uppercase mb-10">{props.date}</p>
          </div>
          <p className="topic">{props.topic}</p>
        </div>
      ) : (
        <Card
          elevation={0}
          className="card chapter-card"
          onClick={() => {
            if (!props.popupDisabled) childRef.current.handleClickOpen();
            props.handler(props.uniqueCode);
          }}
        >
          <div className="card-head">
            {props.showSubjectName && (
              <p className="sub-text uppercase mb-10">{props.subject}</p>
            )}
            <p className="sub-text uppercase mb-10">{props.date}</p>
          </div>
          <p className="topic">{props.topic}</p>
        </Card>
      )}
      <PopUpModal
        ref={childRef}
        header={header}
        body={body}
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
        fullScreen={true}
      />
    </React.Fragment>
  );
};
ChapterCard.propTypes = {
  topic: PropTypes.string,
  date: PropTypes.string,
  handler: PropTypes.func,
  uniqueCode: PropTypes.string,
  list: PropTypes.array,
  subject: PropTypes.string,
  headerText: PropTypes.string,
  showSubjectName: PropTypes.bool,
  homepage: PropTypes.bool,
  popupDisabled: PropTypes.bool
};
ChapterCard.defaultProps = {
  homepage: false,
  popupDisabled: false
};
export default ChapterCard;
